<div class="white-rounded-container width-100vw">

    <!-- <div *ngIf="canUpload" style="margin : 20px 5px">
        <button matButton="filled" >Envoyer une facture electronique</button>
    </div> -->

    <div class="table-button-container">
        <button mat-icon-button color="primary" aria-label="collapse" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
        </button>
    </div>
    <app-prime-ng-array-d4 arrayName="orders" nullArrayDisplayText="Aucune commande" columnResizeMode="fit"
        [columnsDefinition]="columnsDefinition" [objectList]="orders" [heightMode]="'full'" [loading]="loading"
         (itemAction)="rowAction($event)">
    </app-prime-ng-array-d4>
</div>